export const MP_SHOW_PAGE_NAME = 'Gig';
export const MP_ClICKED_NAVBAR = 'Clicked navbar';
export const MP_CLICKED_PACKAGE_SELECT = 'Clicked package select';
export const MP_CLICKED_TAB = 'Gig page tab clicked';
export const MP_CLICKED_COMPARE_PACKAGES = 'Clicked compare packages';
export const MP_CLICKED_SELLER_NAME_ANCHOR = 'Clicked seller name anchor';
export const MP_CLICKED_CUSTOM_ORDER_REQUEST = 'Clicked request custom offer';
export const MP_CLICKED_CONTACT_ME = 'Clicked contact me';
export const MP_CLICKED_GALLERY_FULL_SCREEN = 'Clicked gallery full screen';
export const MP_VIDEO_THUMBNAIL_SIZE = 'gig page - low quality image';
export const MP_CLICKED_BREADCRUMBS_PRO = 'Clicked breadcrumbs pro';
export const MP_CLICKED_BREADCRUMBS_CATEGORY = 'Clicked breadcrumbs category';
export const MP_CLICKED_BREADCRUMBS_SUBCATEGORY = 'Clicked breadcrumbs sub-category';
export const MP_CLICKED_BREADCRUMBS_NESTED_SUBCATEGORY = 'Clicked breadcrumbs nested sub-category';
